import React, { FC } from 'react';

import { Button, ButtonProps } from '@lglp/components';

import styles from './CommonButton.module.scss';

const CommonButton: FC<CommonButtonProps> = ({
  label,
  svg: Icon,
  className,
  reversedColor = false,
  ...rest
}) => {
  return (
    <Button
      className={[
        styles.commonButton,
        reversedColor && styles.reversedColor,
        className,
      ]}
      {...rest}
    >
      {label && <Button.Label>{label}</Button.Label>}
      {Icon && <Icon className={styles.icon} />}
    </Button>
  );
};

export type CommonButtonProps = ButtonProps & {
  label?: string;
  svg?: FC<{ className?: string }>;
  reversedColor?: boolean;
};

export default CommonButton;
